import { IExaminee } from "@tsin-core/models/application.model";

export class ExamineeAction {
  static readonly type = '[Examinee] Add item';
  constructor(public payload: IExaminee) { }
}

export class GetExamApplicantsAction {
  static readonly type = '[Examinee] Get Exam Applicants'
  constructor(public payload: string) { }
}

export class GetExamApplicantsShortAction {
  static readonly type = '[Examinee] Get Exam Applicants Short'
  constructor(public payload: string) { }
}

export class GetSingleExamApplicantAction {
  static readonly type = '[Examinee] Get Single Exam Applicant'
  constructor(public payload: string) { }
}

export type ApplicationStatus =
  | 'Submitted'
  | 'UnderReview'
  | 'Accepted'
  | 'Rejected'
  | 'Waitlisted'
  | 'Withdrawn'
  | 'NoShow'
  | 'ExamChallenged'
  | 'Registered'
  | 'NotRegistered'
  | 'Expired';

export class UpdateExamineeStatusAction {
  static readonly type = '[Examinee] Update Examinee Status';
  constructor(public payload: {
    examId: string;
    status: ApplicationStatus;
    applicationIds: string[];
  }) { }
}

export class ReassignExamineeAction {
  static readonly type = '[Examinee] Reassign Examinee';
  constructor(public payload: {
    examId: string;
    applicationIds: string[];
  }) { }
}

export class AssignExamAdminAction {
  static readonly type = '[Examinee] Assign Exam Admin';
  constructor(public payload: { examId: string }) { }
}

export class ClearExamineesAction {
  static readonly type = '[Examinee] Clear Examinees';
}
